import { Flex } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';
import PetCountInput from './PetCountInput';

import type { ChangeEvent } from 'react';

type MockEventProps = {
  target: {
    name: string;
    value: string | boolean;
    checked?: string | boolean;
  };
  persist?: () => void;
};

type SaveEvent = ChangeEvent<HTMLInputElement> | MockEventProps;

type Props = {
  label: string;
  name: string;
  value: string;
  onChange?: (event: SaveEvent) => void;
  onMinusClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onPlusClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const PetRow = ({ label, name, value, onChange, onMinusClick, onPlusClick }: Props) => {
  return (
    <Flex
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      data-testid="PetsAllowedRow"
    >
      <Text asChild>
        <p>{label}</p>
      </Text>
      <PetCountInput
        name={name}
        value={value}
        onChange={onChange}
        onPlusClick={onPlusClick}
        onMinusClick={onMinusClick}
      />
    </Flex>
  );
};

export default PetRow;
